// Tabs share browser storage, but must not silently adopt a different login.
function createAuthSession({ local, tab, decode, makeId }) {
  const bindingKey = 'vendraw.auth.context'
  const loginKey = 'vendraw.auth.login'
  function context() {
    try {
      const user = JSON.parse(local.getItem('user'))
      const token = decode(local.getItem('accessToken') || '')
      if (!user || !token || !local.getItem('refreshToken')) return ''
      const id = token.id || token._id || token.sub
      if (!id || (user._id && String(user._id) !== String(id))) return ''
      if (user.role && token.selectedRole && user.role !== token.selectedRole) return ''
      return JSON.stringify([local.getItem(loginKey) || '', String(id), token.selectedRole || user.role || ''])
    } catch {
      return ''
    }
  }
  // Preserve the tab's account binding through hard refreshes.
  if (tab.getItem(bindingKey) === null) tab.setItem(bindingKey, context())
  return {
    context,
    isCurrent: () => !!context() && tab.getItem(bindingKey) === context(),
    hasChanged: () => tab.getItem(bindingKey) !== context(),
    adopt() {
      local.setItem(loginKey, makeId())
      const value = context()
      if (!value) throw new Error('Unable to establish the account session. Please sign in again.')
      tab.setItem(bindingKey, value)
      return value
    },
    clear(expected) {
      // A delayed logout must not clear a newer login in another tab.
      if (context() !== expected) return false
      for (const key of ['user', 'accessToken', 'refreshToken', loginKey]) local.removeItem(key)
      tab.setItem(bindingKey, '')
      return true
    },
  }
}

module.exports = { createAuthSession }
